import { logWrapper } from '../../utils';

export default {
  removeDocumentModalController: [
    'runtimeConstant',
    '$scope',
    'revisionListService',
    'EDocumentStatus',
    function (runtimeConstant, $scope, revisionListService, EDocumentStatus) {
      'use strict';

      function parent_cancelButton() {
        $scope.modalRemoveDocument.close();
      }

      function deleteModel() {
        var ids = $scope.docs.map((d) => d.id);

        revisionListService
          .delete(ids)
          .then(() => {
            for (var i = 0, len = $scope.docs.length; i < len; i++) {
              if ($scope.docs[i].idStatus === EDocumentStatus.IN_FLOW) {
                $scope.docs[i].idStatus = EDocumentStatus.IN_FLOW_TRASH_CAN;
              } else if ($scope.docs[i].idStatus !== 3) {
                $scope.docs[i].idStatus = EDocumentStatus.TRASH_CAN;
              }
            }
            if ($scope.docs.some((d) => d.hasLinkedDocuments)) {
              $scope.$broadcast('reloadDocuments');
            }
            $scope.modalRemoveDocument.close();
            $scope.loadDocuments();
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error(error);
          });
      }

      function run() {
        try {
          $scope.$parent.cancelButton = logWrapper(
            parent_cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.deleteModel = logWrapper(
            deleteModel,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
